// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDXxLaUANYwooJBsPmq-trSc2lyj6thbqY",
  authDomain: "suzmesayac-5b48d.firebaseapp.com",
  projectId: "suzmesayac-5b48d",
  storageBucket: "suzmesayac-5b48d.firebasestorage.app",
  messagingSenderId: "78106074652",
  appId: "1:78106074652:web:5f3b996c98809f656ec9d9",
  measurementId: "G-ZZ1C1JS3QE"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { auth, provider };